import React from 'react'
import Navbar from '../../navbar/Navbar'
import "./contact.css"
import Footer from '../../footer/Footer'
function Contact() {
  function submitForm(){
    alert("Successfully Submitted 😊")
  
  }
  return (
    <>
        <Navbar/>
      
    <div className="container">
      <span className="big-circle"></span>
      <img src="images/allpic/shape.png" className="square" alt="" />
      <div className="form">
        <div className="contact-info">
          <h3 className="title">Let's get in touch</h3>
          <p className="text">
            Feel Free to Write us
          </p>

          <div className="info">
            <div className="information">
              <img src="img/location.png" className="icon" alt="" />
              <p> Karhi Road, Amoudha, Satna, Madhya Pradesh , 485002</p>
            </div>
            <div className="information">
              <img src="img/email.png" className="icon" alt="" />
              <p>contactsatna@vitsdpr.ac.in</p>
            </div>
            <div className="information">
              <img src="images/allpic/phone.png" className="icon" alt="" />
              <p>6264282808</p>
            </div>
          </div>

          <div className="social-media">
            <p>Connect with us :</p>
            <div className="social-icons">
              <a href="https://www.facebook.com/SatnaVitsCollege" target='_blank'>
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="https://twitter.com/vits_satna" target='_blank'>
                <i className="fab fa-twitter"></i>
              </a>
              <a href="https://www.instagram.com/vitscollegesatna" target='_blank'>
                <i className="fab fa-instagram"></i>
              </a>
              <a href="#">
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="contact-form">
          <span className="circle one"></span>
          <span className="circle two"></span>

          <form onSubmit={submitForm}>
            <h3 className="title">Contact us</h3>
            <div className="input-container">
              <input type="text" name="name" className="input" placeholder='username' required />

            </div>
            <div className="input-container">
              <input type="email" name="email" className="input" placeholder='email' required />
            </div>
            <div className="input-container">
              <input type="tel" name="phone" className="input" placeholder='phone' required/>

            </div>
            <div className="input-container textarea">
              <textarea name="message" className="input" placeholder='message' required></textarea>
            </div>
            <input type="submit" value="Send" className="btn" />
          </form>
        </div>
      </div>
    </div>
    <Footer/>
    </>
  )
}

export default Contact